export default __webpack_public_path__ + "static/media/avatar_whitney2.228a243b.mp3";